import React from 'react';
import '../css/TripId.css';

const TripID = ({ id }) => {
  return (
    <div className="trip-id-container">
      <span data-testid="trip-id-label">Trip ID</span>
      <div className="trip-id-box">
        <p data-testid="trip-id-value">{id}</p>
      </div>
    </div>
  );
};

export default TripID;